import styled, { css } from 'styled-components/macro';
import { Checkbox } from '@Thread-Magic/jasmine';

export const Wrapper = styled.div`
  display: flex;
  height: calc(100% + 40px);
`;

export const CustomCheckbox = styled(Checkbox)`
  max-width: ${({ maxWidth }) => maxWidth || 'auto'};
  width: 100%;
  font-weight: 600;
  text-transform: capitalize;
`;

export const Form = styled.form`
  position: relative;
  width: 100%;
  padding: 36px 40px;

  ${({ disabled }) =>
    disabled &&
    css`
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: calc(100% - 100px);
        background-color: #ffffff94;
      }
    `}
`;

export const FormGroup = styled.fieldset`
  margin-bottom: 24px;
`;

export const Error = styled.p`
  margin: -12px 0 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.colors.red1};
`;

export const Separator = styled.hr`
  background-color: ${({ theme }) => theme.colors.background.secondary};
`;

export const Title = styled.h2`
  margin-bottom: 15px;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
`;

export const Description = styled.p`
  max-width: 600px;
  margin-bottom: 28px;
  font-size: 14px;
  line-height: 18px;
  color: #000000;
`;

export const SubTitle = styled.h3`
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
`;
